import { FC, HTMLProps, MouseEventHandler } from 'react';
import { useTranslation } from '../../../utils/i18n';

interface Props extends Omit<HTMLProps<HTMLButtonElement>, 'onClick' | 'type'> {
  name: string;
  city?: string;
  count?: number;
  onClick: (term: string) => void;
}

const Location: FC<Props> = ({
  name,
  city,
  count = 0,
  onClick,
  className = 'location__search-result__button',
  role = 'option',
  ...props
}) => {
  const { t } = useTranslation('common');

  const formatAggregateWithCount = (name: string, count = 0): string =>
    count === 0
      ? name
      : t('location_field.location_aggregate', { name, count });

  return (
    <button
      className={className}
      role={role}
      type="button"
      {...props}
      onClick={onClick as unknown as MouseEventHandler<HTMLButtonElement>}
    >
      {city ? (
        <>
          {name}
          <span className="location__search-result__city">
            , {formatAggregateWithCount(city, count)}
          </span>
        </>
      ) : (
        formatAggregateWithCount(name, count)
      )}
    </button>
  );
};

export default Location;
